firebird.factory('betaSettingsService', [
    '$rootScope',
    'meetingService',
    'attendeeService',
    'logService',
    function ($rootScope, meetingService, attendeeService, logService) {
        var betaSettingsAvailable = false;

        var availableSettings = {
            LAYOUT_LOCK: false,
            BLUR: false
        };

        var service = {
            init: init,
            getAvailableSettings: getAvailableSettings,
            shouldShowBetaTab: shouldShowBetaTab
        };

        return service;

        ////////////////////////

        function init() {
            logService.log('betaSettingsService init');

            if (attendeeService.getIsHost() && meetingService.getLayoutLockEnabled()) {
                availableSettings.LAYOUT_LOCK = true;
            }

            if (!meetingService.getVirtualBackgroundEnabled()) {
                availableSettings.BLUR = true;
            }

            //If at least one Beta Setting is available, show the Beta Settings tab
            for (var betaSetting in availableSettings) {
                if (availableSettings[betaSetting]) {
                    betaSettingsAvailable = true;
                    break;
                }
            }
        }

        function getAvailableSettings() {
            return availableSettings || {};
        }

        function shouldShowBetaTab() {
            return betaSettingsAvailable;
        }
    }
]);
